import { SidePanelDetailSectionTemplate } from "components/MainSectionTemplate/SidePanelSection/SidePanelDetailSectionTemplate";
import React from "react";
import { formatTime, formatWrittenDayMonthYear } from "utilities";
import { ArtistSidePanel } from "../Company/CompanySidePanel";
import { SidePanelContactList } from "../contact/SidePanelContactList";
import AppointmentPhase from "components/Atoms/AppointmentPhase";
import { SidePanelDepartureArrival } from "../details/SidePanelDepartureArrival";
import { JourneySegment } from "components/Atoms/JourneySegment";
import { AirportSidePanel } from "../Airport/AirportSidePanel";

interface FlightSidePanelDetailsProps {
  flightSegmentId: number
  flight: server.dto.Flight
}

export const FlightSidePanelDetails = (props: FlightSidePanelDetailsProps) => {
  const { flight } = props;

  const flightSegment = flight.segments.find(segment => segment.id === props.flightSegmentId);

  const startDateWritten = formatWrittenDayMonthYear(flightSegment.departure.dateTimeLocal);
  const endDateWritten = formatWrittenDayMonthYear(flightSegment.departure.dateTimeLocal);

  const startTimeWritten = formatTime(flightSegment.departure.dateTimeLocal);
  const endTimeWritten = formatTime(flightSegment.arrival.dateTimeLocal);

  return <SidePanelDetailSectionTemplate
    isInPageEditable={false}
    onValueChanged={() => { }}
    fields={[{
      key: "artist",
      label: site.currentEnvironment.functionGroups.artist.singular,
      isEmpty: !flight.artist,
      render: () => <ArtistSidePanel
        companyId={flight.artist.artistId}
        trigger={<a>{flight.artist.name}</a>}
        fallbackIfNoPermission={<>{flight.artist.name}</>}
      />
    }, {
      key: "travellers",
      label: RESX.Flight.Travellers,
      isEmpty: flight.travellers.length === 0,
      render: () => <SidePanelContactList contacts={flight.travellers} />
    }, {
      key: "status",
      label: RESX.Status.resxStatus,
      render: () => <AppointmentPhase value={flight.phase} displayLabel />
    }, {
      key: "departureArrival",
      label: "",
      hideLabel: true,
      render: () => <>
        <SidePanelDepartureArrival
          dateWritten={startDateWritten}
          timeWritten={startTimeWritten}
          sideInfo={flightSegment.departure.airport.iata || flightSegment.departure.airport.icao}
          addressLine1={<AirportSidePanel airportId={flightSegment.departure.airport.airportId} trigger={<a onClick={() => { }}>{flightSegment.departure.airport.name}</a>} />}
          addressLine2={`${flightSegment.departure.airport.location}`}
        />

        <JourneySegment
          duration={flightSegment.duration}
          distance={flightSegment.distanceInMeters}
        />

        <SidePanelDepartureArrival
          dateWritten={endDateWritten !== startDateWritten ? endDateWritten : undefined}
          timeWritten={endTimeWritten}
          sideInfo={flightSegment.arrival.airport.iata || flightSegment.arrival.airport.icao}
          addressLine1={<AirportSidePanel airportId={flightSegment.arrival.airport.airportId} trigger={<a onClick={() => { }}>{flightSegment.arrival.airport.name}</a>} />}
          addressLine2={`${flightSegment.arrival.airport.location}`}
        />
      </>
    }, {
      key: "flightNumber",
      label: RESX.Flight.FlightNumber,
      render: () => <span>{flightSegment.flightNumber}</span>
    }, {
      key: "seats",
      label: RESX.Flight.Seats,
      isEmpty: !flightSegment.seats,
      render: () => <span>{flightSegment.seats}</span>
    }, {
      key: "airline",
      label: RESX.Flight.Airline,
      isEmpty: !flightSegment.airline,
      render: () => <span>{flightSegment.airline.name}</span>
    }, {
      key: "bookingCode",
      label: RESX.Flight.BookingCode,
      isEmpty: !flight.bookingCode,
      render: () => <span>{flight.bookingCode}</span>
    }]}
  />
}